<template>
<div class="content content--fullpage content--login">
  <input class="pinInput"
         type="password"
         v-model="pin"
         autofocus
         @keyup.enter="authenticate">

  <button class="pinSubmit" @mousedown="authenticate">Log in</button>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';

export default {
  data(){ return {
    pin: ''
  }},

  methods: {
    authenticate(){
      firebase.auth().signInWithEmailAndPassword('hello@sorav.it', this.pin)
      .then(() => {
        this.$router.push('/');
      })
      .catch(error => {
        if(error.code === 'auth/wrong-password'){
          console.log('Wrong PIN');
        }
      });
    }
  },

  mounted(){
    if(firebase.auth().currentUser){
      //already signed in, redirect to main page
      this.$router.replace('/');
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.vue?cf055928